export const TestIds = {
  topBar: {
    rocheLogo: 'ces-top-bar-roche-logo',
    search: 'ces-top-bar-btn-search',
    favorite: 'ces-top-bar-favorite',
  },
};
